import { ASSESSMENT_SLUG } from "core/consts";
import { Auction, GetOntologyType } from "core/types";
import { PatientInfoSlugContext } from "dsl/organisms/PatientProfileDetailsShared";
import { PatientProfileInfoCard } from "dsl/organisms/PatientProfileDetailsShared/shared";
import Translations from "translations/types";
import { MainContactInformation } from "./AdmissionsMainContactCard";

export function AdmissionsMainContactCardPrint({
  auction,
  getOntology,
  isSealdOnly,
  translations,
  withEncryptionAccess,
}: {
  auction: Auction;
  getOntology: GetOntologyType;
  translations: Translations;
  isSealdOnly: boolean;
  withEncryptionAccess: boolean;
}) {
  return (
    <PatientInfoSlugContext.Provider
      value={{
        assessmentSlug: ASSESSMENT_SLUG.INFO,
        auctionId: auction.id,
        patientId: auction.patient.id,
      }}
    >
      <PatientProfileInfoCard
        title={
          translations.careproviderApp.recareAdmissionsForm
            .contactPersonInformation.title
        }
      >
        <MainContactInformation
          auction={auction}
          getOntology={getOntology}
          isSealdOnly={isSealdOnly}
          translations={translations}
          withEncryptionAccess={withEncryptionAccess}
        />
      </PatientProfileInfoCard>
    </PatientInfoSlugContext.Provider>
  );
}
